module.exports = __webpack_public_path__ + "static/tour-b-map-fdebb3d78cac8269184430129f00cced.png";